export const INVALID_IMAGE_REASONS = [
  "NOT_NAMEPLATE",
  "BLURRY",
  "MULTIPLE_NAMEPLATES",
  "OTHER_REASON",
] as const;

export const PIPELINE_ERROR_REASONS = ["LLM_ERROR", "DATA_ERROR", "UNKNOWN_ERROR"] as const;

export const FAILED_STEP_KEYS: Record<string, string> = {
  brand: "views.captureView.failedStep.brand",
  category: "views.captureView.failedStep.category",
  sub_category: "views.captureView.failedStep.subCategory",
  product: "views.captureView.failedStep.product",
  serial_number: "views.captureView.failedStep.serialNumber",
  full_information: "views.captureView.failedStep.fullInformation",
};
